/**
 * URL-param debug harness: ?debug ?stress ?pattern=<id> ?seed=<s> ?floor=<n>
 * ?god ?grant=<artifactId> ?zoom=<z> ?vault (force a Reliquary door per floor)
 * ?tier=<n> (force a ladder tier, bypassing unlocks — marks the run
 * record-ineligible and tithe-neutral)
 * ?char=<id> (force a character, bypassing unlocks — record-ineligible)
 * ?boss=<id> (force a boss-pool draw: warden/horror/bellkeeper/esoterium/
 * gravemother — record-ineligible)
 * ?mapgen=<archetype> (force a chunk layout: mixed/warrens/halls/sanctum —
 * record-ineligible; chunk floors are the default since the P4 flip)
 * ?vaultLayout=<id> (force a Reliquary layout: spine/ring/cross/hall —
 * record-ineligible; pair with ?vault to see one every floor)
 */
const params = new URLSearchParams(location.search);

export const DebugFlags = {
  debug: params.has('debug'),
  stress: params.has('stress'),
  pattern: params.get('pattern'),
  seed: params.get('seed'),
  floor: params.get('floor') ? Number(params.get('floor')) : null,
  god: params.has('god'),
  grant: params.get('grant'),
  zoom: params.get('zoom') ? Number(params.get('zoom')) : null,
  vault: params.has('vault'),
  tier: params.get('tier') ? Number(params.get('tier')) : null,
  char: params.get('char'),
  boss: params.get('boss'),
  mapgen: params.get('mapgen'),
  vaultLayout: params.get('vaultLayout'),
} as const;
